export default "__VITE_ASSET__AgzQYIfy__"